var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-pickr',_vm._b({attrs:{"disabled":_vm.disabled,"placeholder":"MM/DD/YYYY"},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},'flat-pickr',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }